<template>
    <div class="ma-5">
        <v-data-table
            :headers="headers"
            :items="desserts"
            :search="search"
            :height="320"
            :fixed-header="true"
            class="elevation-3"
        >
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Cadastro de Zonas Geográficas</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>

                    <v-text-field
                        class="mr-10"
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Pesquisar"
                        single-line
                        hide-details
                    ></v-text-field>

                    <v-dialog persistent v-model="dialog" max-width="600px">
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark class="mb-2" v-on="on">Novo</v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col class="pa-0" cols="12" xs="12">
                                            <v-text-field
                                                outlined
                                                v-model="editedItem.nome"
                                                label="Nome da Zona Geográfica*"
                                                autofocus
                                                :error-messages="nomeErrors"
                                                @input="$v.editedItem.nome.$touch()"
                                                @blur="$v.editedItem.nome.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close">Sair</v-btn>
                                <v-btn color="blue darken-1" text @click="save">Salvar</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon
                    title="Editar Zona Geográfica"
                    class="mr-2"
                    @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                    title="Remover Zona Geográfica"
                    @click="deleteItem(item)"
                >
                    mdi-delete
                </v-icon>
            </template>
        </v-data-table>
    </div>
</template>
<script>
    import { required } from 'vuelidate/lib/validators'
    import AclAPI from "./../../api/acl";

    export default {
        name: "ZonasGeograficas",
        data: () => ({
            dialog: false,
            atualizar: 0,
            search: '',
            headers: [
                { text: 'ID', value: 'id' },
                { text: 'Zona Geográfica', align: 'left', value: 'nome' },
                { text: 'Ações', value: 'action', sortable: false },
            ],
            desserts: [],
            editedIndex: -1,
            editedItem: {
                id: '',
                nome: '',
            },
            defaultItem: {
                id: '',
                nome: '',
            },
        }),

        validations: {
            editedItem: {
                nome: {
                    required,
                    unica(value) {
                        if (value === '' || value === null || value === undefined) return true;
                        const idAtual = this.editedItem.id;
                        const alvo = String(value).trim().toLowerCase();
                        return !this.desserts.some(z =>
                            String(z.nome).trim().toLowerCase() === alvo && z.id !== idAtual
                        );
                    },
                },
            }
        },

        computed: {
            nomeErrors() {
                const errors = []
                if (!this.$v.editedItem.nome.$dirty) return errors
                !this.$v.editedItem.nome.required && errors.push('Campo Obrigatório.')
                !this.$v.editedItem.nome.unica && errors.push('Zona geográfica já cadastrada.')
                return errors
            },
            formTitle() {
                return this.editedIndex === -1 ? 'Nova Zona Geográfica' : 'Editar Zona Geográfica'
            },
        },

        watch: {
            dialog(val) {
                val || this.close()
            },
        },

        created() {
            this.initialize()
        },

        methods: {
            initialize() {

                const headers = this.Helpers.iniciarRequisicao();

                AclAPI.getZonasGeograficas(headers)
                    .then(response => {

                        const token = response.data.token;
                        localStorage.setItem('token', token);

                        if (response.status == 200) {
                            this.desserts = response.data.zonas_geograficas;
                        }
                    })
                    .catch(() => {
                        this.Helpers.logout();
                    })

                this.$store.dispatch("loading/habilitarLoading", false);
            },

            editItem(item) {
                this.editedIndex = this.desserts.indexOf(item)
                this.editedItem = { id: item.id, nome: item.nome }
                this.dialog = true
            },

            deleteItem(item) {

                this.editedItem = { id: item.id, nome: item.nome }

                if (confirm('Deseja remover a zona geográfica?')) {

                    const headers = this.Helpers.iniciarRequisicao();
                    const params = { id: this.editedItem.id };

                    this.$store.dispatch("loading/addRequisicao",
                        AclAPI.delZonaGeografica(headers, params)
                            .then(response => {

                                const token = response.data.token;
                                localStorage.setItem('token', token);

                                if (response.status == 200) {
                                    this.editedItem = Object.assign({}, this.defaultItem)
                                    this.initialize();
                                    this.$emit('atualizarApp', this.atualizar += 1)
                                }
                            })
                            .catch(() => {
                                this.Helpers.logout();
                            })
                    )

                } else {
                    this.editedItem = Object.assign({}, this.defaultItem)
                }
            },

            close() {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                    this.$v.$reset()
                }, 300)
            },

            save() {

                this.$v.$touch();

                if (!this.$v.$invalid) {

                    const headers = this.Helpers.iniciarRequisicao();
                    const params = {
                        id: this.editedItem.id || 0,
                        nome: String(this.editedItem.nome).trim(),
                    };

                    this.$store.dispatch("loading/addRequisicao",
                        AclAPI.addZonaGeografica(headers, params)
                            .then(response => {

                                const token = response.data.token;
                                localStorage.setItem('token', token);

                                if (response.status == 200) {
                                    this.initialize();
                                    this.$emit('atualizarApp', this.atualizar += 1)
                                    this.close()
                                }
                            })
                            .catch(error => {
                                if (error.response && error.response.status === 409) {
                                    this.$store.dispatch('snackbar/habilitarSnackBar', {
                                        ativo: true,
                                        mensagem: 'Zona geográfica já cadastrada.',
                                        color: 'error',
                                        timeout: 4000,
                                    });
                                } else {
                                    this.Helpers.logout();
                                }
                            })
                    )
                }
            },
        },
    }
</script>
<style scoped>
</style>
